import { render, staticRenderFns } from "./TheAttachmentManager.vue?vue&type=template&id=5250b284"
import script from "./TheAttachmentManager.vue?vue&type=script&lang=js"
export * from "./TheAttachmentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports